import React from "react";
import { SonarGrid } from "@/components/ui/sonar-grid";
import { Wrench } from "lucide-react";

function Countdown({ until }) {
  const [now, setNow] = React.useState(Date.now());
  React.useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const ms = new Date(until).getTime() - now;
  if (isNaN(ms) || ms <= 0) return <span data-testid="maintenance-countdown">Retour imminent…</span>;
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return <span data-testid="maintenance-countdown" className="tabular-nums">{h > 0 ? `${h}h ` : ""}{pad(m)}min {pad(sec)}s</span>;
}

export function MaintenancePage({ status }) {
  const until = status?.until ? new Date(status.until) : null;
  return (
    <SonarGrid
      gradient={["#FF6A00", "#FFD500"]}
      interactive={false}
      style={{ backgroundColor: "#09090b", color: "#ffffff" }}
      className="flex min-h-screen items-center justify-center px-4"
    >
      <div data-testid="maintenance-page" className="relative z-10 max-w-md text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl" style={{ background: "rgba(255,106,0,0.15)", color: "#FF6A00" }}>
          <Wrench className="h-8 w-8" />
        </div>
        <h1 className="font-display text-3xl font-bold" style={{ color: "#ffffff" }}>Application en mise à jour</h1>
        <p className="mt-3 text-base" style={{ color: "#a1a1aa" }}>
          {status?.message || "HalgarOS est momentanément indisponible pour une mise à jour. Merci de patienter quelques instants et de réessayer."}
        </p>
        {until && (
          <div className="mt-6 inline-flex flex-col items-center gap-1 rounded-2xl px-6 py-4" style={{ border: "1px solid #27272a", background: "rgba(9,9,11,0.7)" }}>
            <span className="text-xs uppercase tracking-wide" style={{ color: "#71717a" }}>Retour estimé dans</span>
            <span className="font-display text-2xl font-bold" style={{ color: "#FFD500" }}><Countdown until={status.until} /></span>
            <span className="text-xs" style={{ color: "#a1a1aa" }}>
              vers {until.toLocaleString("fr-FR", { weekday: "short", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" })}
            </span>
          </div>
        )}
      </div>
    </SonarGrid>
  );
}

export default MaintenancePage;
